"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODAL_MAX_HEIGHT = exports.MODAL_HEIGHT = void 0;
exports.MODAL_HEIGHT = '400px';
exports.MODAL_MAX_HEIGHT = '80vh';
